module.exports = __webpack_public_path__ + "img/exit.png?c9322b9d4a0a2f31bec8f90be476117f";